import React from 'react';
import { 
    IonContent, 
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonMenu, 
    IonMenuToggle,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuButton,
    IonTitle
} from '@ionic/react';
import { 
    settings, 
    document, 
    home,
    statsChart,
    people,
    airplane
} from 'ionicons/icons';
import { useLocation } from 'react-router';
import { appSubDir } from '../configs/app';
import './AdminLayout.scss';

type Props = {
    title: string;
    children: React.ReactNode;
};

const AdminLayout: React.FC<Props> = ({ title, children }) => {
    const location = useLocation();

    const handleBackToSite = () => {
        window.location.href = appSubDir || '/';
    };

    const menuItems = [
        {
            title: 'Dashboard',
            icon: statsChart,
            path: appSubDir + 'admin/dashboard',
        },
        {
            title: 'All Orders',
            icon: document,
            path: appSubDir + 'admin/orders',
        },
        {
            title: 'Shipping Bookings',
            icon: airplane,
            path: appSubDir + 'admin/shipping-bookings',
        },
        {
            title: 'Users',
            icon: people,
            path: appSubDir + 'admin/users',
        },
        {
            title: 'Settings',
            icon: settings,
            path: appSubDir + 'admin/settings',
        },
    ];

    const isActive = (path: string) => {
        return location.pathname === path || location.pathname === path + '/';
    };

    return (
        <>
            <IonMenu contentId="admin-main" type="overlay" className="admin-sidebar">
                <IonContent>
                    <div className="admin-sidebar-header">
                        <h2>Admin Panel</h2>
                    </div>
                    <div className="admin-sidebar-menu">
                        <IonMenuToggle autoHide={false}>
                            <IonItem 
                                button 
                                onClick={handleBackToSite}
                                lines="none"
                                className="sidebar-item"
                            >
                                <IonIcon slot="start" icon={home} />
                                <IonLabel>Back to Site</IonLabel>
                            </IonItem>
                        </IonMenuToggle>

                        <div className="sidebar-divider"></div>

                        {menuItems.map((item, index) => (
                            <IonMenuToggle key={index} autoHide={false}>
                                <IonItem
                                    button
                                    routerLink={item.path}
                                    lines="none"
                                    className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
                                >
                                    <IonIcon slot="start" icon={item.icon} />
                                    <IonLabel>{item.title}</IonLabel>
                                </IonItem>
                            </IonMenuToggle>
                        ))}
                    </div>
                </IonContent>
            </IonMenu>

            <IonPage id="admin-main">
                <IonHeader>
                    <IonToolbar color="primary" className="admin-topbar">
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>{title}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="admin-content">
                    {children}
                </IonContent>
            </IonPage>
        </>
    );
};

export default AdminLayout;
